<jhi-custom-box [title]="isFirstLogin ? (user ? 'spans.firstLogin.boxtitle' : 'spans.firstLogin.boxtitlenouser')
            : (user ? 'spans.changePassword.boxtitle' : 'spans.changePassword.boxtitlenouser')"
                [errorMsg]="errorMsg" [requiredFields]="canAccessForm"
                [translateParams]="{username: user?.login}"
                [boxSize]="'box-620'"
                [successMsg]="successMsg"
                [contentLoading]="loading"
                (successEmitter)="redirect()"
                [successButtonLabel]="isFirstLogin ? 'buttons.returntoapp' : 'buttons.ok'"
                (failureEmitter)="backToApp()"
                *ngIf="!showPasswordRules">

    <!-- Warning message for non-EXTRA_UE users when passwordless mode is enabled -->
    <div class="text-center mt-3 mb-3" *ngIf="!canAccessForm && pwdlessWarningMessage">
        <p class="text-danger">
            {{ pwdlessWarningMessage }}
        </p>
    </div>

    <!-- Show form only if user can access it -->
    <div *ngIf="canAccessForm">
        <div class="row p-0 mb-3" *ngIf="isFirstLogin">
            <div class="col-12 text-center">
                <span class="text-orange" jhiTranslate="spans.firstLogin.mandatoryChange"></span>
                <br>
                <span class="text-orange" jhiTranslate="spans.firstLogin.reauth"></span>
            </div>
        </div>


        <div class="row p-0 mb-3">
            <div class="col-sm-12 text-center">
                <a placement="right" class="blue-anchor" jhiTranslate="spans.changePassword.passwordRules"
                   (click)="showPasswordRules = true">
                </a>
            </div>
        </div>

        <form [formGroup]="passwordForm" >

        <div class="form-group">
            <div class="row">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" jhiTranslate="spans.changePassword.formlabels.username"> Username </label>
                </div>

                <div class="col-sm-8">
                    <span class="font-weight-bold">{{ user?.login }}</span>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="oldPassword-input" jhiTranslate="spans.changePassword.formlabels.oldPassword"> Old password </label>
                </div>
                <div class="col-sm-8 input-group">
                    <input [readOnly]="submitted"  id="oldPassword-input" [type]="showOld ? 'text' : 'password'"
                           [formControlName]="'oldPassword'"
                           class="form-control" [ngClass]="f.oldPassword.invalid ? 'is-invalid': ''"
                           autofocus />
                    <div class="input-group-append">
                        <button tabindex="-1" title="{{showOld ? 'spans.changePassword.hideOldPassword' : 'spans.changePassword.showOldPassword' | translate}}"
                                type="button" class="btn btn-outline-secondary align-self-start" (click)="changeShowPassword(PassType.OLD)">
                            <fa-icon [icon]="showOld ? faEye : faEyeSlash"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-8 align-self-end">
                    <div *ngIf="fOldPassword.invalid" class="error-box">
                        <span *ngIf="fOldPassword.errors?.required" jhiTranslate="spans.changePassword.formerrors.requiredOldPassword"> Old password required </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="newPassword-input" jhiTranslate="spans.changePassword.formlabels.newPassword"> Answer </label>
                </div>
                <div class="col-sm-8 input-group">
                    <input [readOnly]="submitted" id="newPassword-input" [type]="showNew ? 'text' : 'password'" [formControlName]="'newPassword'"
                           class="form-control" [ngClass]="f.newPassword.errors ? 'is-invalid': ''" />
                    <div class="input-group-append">
                        <button tabindex="-1" title="{{showNew ? 'spans.changePassword.hideNewPassword' : 'spans.changePassword.showNewPassword' | translate}}"
                                type="button" class="btn btn-outline-secondary align-self-start" (click)="changeShowPassword(PassType.NEW)">
                            <fa-icon [icon]="showNew ? faEye : faEyeSlash"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-8 align-self-end">
                    <div *ngIf="fNewPassword.invalid" class="error-box">
                        <span *ngIf="fNewPassword.errors?.required" jhiTranslate="spans.changePassword.formerrors.requiredNewPassword"> Answer required </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-5">
                <div class="col-sm-4 mb-auto mt-auto" [ngClass]="{'text-right': isDesktop}">
                    <label class="mb-0" for="confirmNewPassword-input" jhiTranslate="spans.changePassword.formlabels.confirmNewPassword"> Confirm new password </label>
                </div>
                <div class="col-sm-8 input-group">
                    <input [readOnly]="submitted" id="confirmNewPassword-input" [type]="showConfirm ? 'text' : 'password'"
                           [formControlName]="'confirmNewPassword'" class="form-control" [ngClass]="f.confirmNewPassword.errors ? 'is-invalid': ''" />
                    <div class="input-group-append">
                        <button tabindex="-1" title="{{showConfirm ? 'spans.changePassword.hideConfirmPassword' : 'spans.changePassword.showConfirmPassword'  | translate}}"
                                type="button" class="btn btn-outline-secondary align-self-start" (click)="changeShowPassword(PassType.CONFIRM)">
                            <fa-icon [icon]="showConfirm ? faEye : faEyeSlash"></fa-icon>
                        </button>
                    </div>
                </div>
                <div class="col-sm-4"></div>
                <div class="col-sm-8 align-self-end">
                    <div *ngIf="fConfirmNewPassword.invalid" class="error-box">
                        <span *ngIf="fConfirmNewPassword.errors?.required" jhiTranslate="spans.changePassword.formerrors.requiredConfirmNewPassword"> Confirm new password required </span>
                    </div>
                    <div class="error-box">
                        <span *ngIf="passwordForm.errors?.fieldMatch" jhiTranslate="spans.changePassword.formerrors.passwordDoNotMatch"> Confirm password doesn't match </span>
                    </div>
                </div>
            </div>

        </div>


        <div class="row text-center d-flex">
            <div class="col-12">
                <button [disabled]="submitted" type="button" class="btn secondary-btn float-left" (click)="backToApp()"
                        jhiTranslate="buttons.back">Return to application</button>
                <button [disabled]="submitted" (click)="onReset()" class="btn secondary-btn" jhiTranslate="buttons.discard">Discard</button>
                <button [ladda]="submitted" class="btn confirm-btn ladda-button max-w-150" data-style="expand-right"
                        [disabled]="!(passwordForm.valid && passwordForm.dirty)" (click)="onSubmit()">
                    <span class="ladda-label" jhiTranslate="{{ isFirstLogin ? 'buttons.ahead' : 'buttons.submit' }}"></span>
                </button>
            </div>

        </div>
    </form>
    </div>

    <!-- Back button for users who cannot access the form -->
    <div class="row text-center d-flex" *ngIf="!canAccessForm">
        <div class="col-12">
            <button type="button" class="btn secondary-btn" (click)="backToApp()"
                    jhiTranslate="buttons.back">Return to application</button>
        </div>
    </div>

</jhi-custom-box>

<jhi-custom-box [boxSize]="'box-580'" *ngIf="showPasswordRules"
                [title]="'spans.changePassword.passwordRules'">
    <div class="p-0">
        <span jhiTranslate="spans.changePassword.rules.must"> must </span>
        <ul>
            <li jhiTranslate="spans.changePassword.rules.oneNumber"> one numeric </li>
            <li jhiTranslate="spans.changePassword.rules.oneUpper"> one uppercase </li>
            <li jhiTranslate="spans.changePassword.rules.oneSpecial"> one special char </li>
            <li jhiTranslate="spans.changePassword.rules.startAlphabet"> start with alphabet </li>
            <li jhiTranslate="spans.changePassword.rules.different"> different from user - first name - last name </li>
            <li jhiTranslate="spans.changePassword.rules.notAllowedChars"> not allowed chars</li>
            <li jhiTranslate="spans.changePassword.rules.differentLast10"> different from last 10</li>
        </ul>
    </div>
    <button class="btn confirm-btn ladda-button max-w-120" data-style="expand-right"
            (click)="showPasswordRules = !showPasswordRules">
        <span class="ladda-label" jhiTranslate="buttons.back" ></span>
    </button>
</jhi-custom-box>
